<template>
  <v-container id="data-tables" tag="section">
    <base-material-card color="blue" icon="mdi-file-check-outline" inline class="px-5 py-3">
      <v-spacer></v-spacer>
      <template v-slot:after-heading></template>
      <!-- Texto del boton NUEVO -->
      <template v-slot:corner-button>
        <v-btn
          small
          class="ma-2"
          elevation="2"
          color="blue"
          @click="nuevaCaptura"
          @click.stop="dialog = true"
          >Nueva Captura</v-btn
        >
      </template>

      <!-- <v-overlay :value="overlay">
        <v-progress-circular :size="50" color="green" indeterminate></v-progress-circular>
      </v-overlay> -->

      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        class="ml-auto"
        label="Búsqueda"
        hide-details
        single-line
        style="max-width: 250px"
      />
      <!-- Empieza Dialogo Cancelar -->
      <ConfirmationDialog v-model="isSure" @click="cancel" />
      <!-- Termina Dialogo Cancelar -->
      <!--DELETE Dialog End----------------------------------------------------------START---->
      <v-row justify="center">
        <v-dialog v-model="deleteDocumentDialog" persistent width="30%">
          <v-card>
            <v-card-title>
              <v-icon color="red"></v-icon>
            </v-card-title>
            <v-card-text class="BYekan"> Estas seguro de Borrar el Archivo? </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                class="BYekan"
                color="green darken-1"
                text
                @click="deleteDocumentDialog = false"
                >Cancela</v-btn
              >
              <v-btn
                class="BYekan"
                color="primary"
                :disabled="btnLoader"
                :loading="btnLoader"
                @click="deleteDocument"
                >Borrar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
      <!--DELETE Dialog End----------------------------------------------------------------END---->
      <!--Insert New Document Dialog Start-->
      <v-row justify="center">
        <v-dialog v-model="insertDocumentDialog" :scrollable="false" persistent width="600px">
          <v-card>
            <v-card-title>
              <v-icon @click="insertDocumentDialog = false">mdi-close</v-icon>
            </v-card-title>
            <v-card-text class="BYekan">
              <template v-if="tempAttachment.length === 0">
                <v-file-input
                  v-if="fileAccept !== ''"
                  multiple
                  :accept="fileAccept"
                  chip
                  v-model="tempAttachment"
                  label="Agrega Nuevo Archivo"
                ></v-file-input>
                <v-file-input
                  v-else
                  multiple
                  v-model="tempAttachment"
                  label="Agrega Nuevo Archivo"
                ></v-file-input>
              </template>
              <template>
                <v-expansion-panels v-if="addFileTag || addFileDescription || changeFileName">
                  <v-expansion-panel
                    v-for="(attachment, index) in tempAttachmentChanged"
                    :key="`attachment-${index}`"
                  >
                    <v-expansion-panel-header>
                      <div class="one-line">
                        {{ attachment.name }}
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row align="center" justify="center">
                        <v-col cols="12" lg="9" md="9" xs="12">
                          <v-text-field
                            v-if="changeFileName"
                            label="Nombre de archivo"
                            v-model="attachment.name"
                            :prepend-icon="attachment.icon"
                          >
                          </v-text-field>
                          <!--                           <v-textarea
                            v-if="addFileDescription"
                            :label="selectedLang[lang].fileDescription"
                            auto-grow
                            row-height="1"
                            v-model="attachment.description"
                          >
                          </v-textarea>
 -->
                          <!-- <v-autocomplete
                            v-if="addFileTag"
                            v-model="attachment.tags"
                            :items="tags"
                            dense
                            chips
                            :label="selectedLang[lang].fileTags"
                            multiple
                          ></v-autocomplete> -->
                        </v-col>
                        <v-col align="center" cols="12" lg="3" md="3" xs="12">
                          <template
                            v-if="
                              attachment.format === 'jpg' ||
                              attachment.format === 'jpeg' ||
                              attachment.format === 'png' ||
                              attachment.format === 'tif' ||
                              attachment.format === 'bmp'
                            "
                          >
                            <v-card>
                              <v-img :src="attachment.base64"></v-img>
                            </v-card>
                          </template>
                          <template v-else>
                            <v-icon
                              v-if="attachment.format === 'pdf'"
                              size="60"
                              file-word-outline
                              color="red darken-1"
                              >mdi-file-pdf-outline</v-icon
                            >
                            <v-icon
                              v-else-if="
                                attachment.format === 'doc' ||
                                attachment.format === 'docx' ||
                                attachment.format === 'odt'
                              "
                              size="60"
                              file-word-outline
                              color="blue darken-1"
                              >mdi-file-word-outline</v-icon
                            >
                            <v-icon
                              v-else-if="
                                attachment.format === 'jpg' ||
                                attachment.format === 'jpeg' ||
                                attachment.format === 'png' ||
                                attachment.format === 'tif' ||
                                attachment.format === 'bmp'
                              "
                              size="60"
                              file-word-outline
                              color="deep-purple darken-1"
                              >mdi-file-image-outline</v-icon
                            >
                            <v-icon
                              v-else-if="
                                attachment.format === 'xls' || attachment.format === 'xlsx'
                              "
                              size="60"
                              file-word-outline
                              color="teal darken-1"
                              >mdi-file-excel-outline</v-icon
                            >
                            <v-icon
                              v-else-if="
                                attachment.format === 'pptx' ||
                                attachment.format === 'pptm' ||
                                attachment.format === 'ppt'
                              "
                              size="60"
                              file-word-outline
                              color="orange darken-3"
                              >mdi-file-powerpoint-outline</v-icon
                            >
                            <v-icon
                              v-else-if="
                                attachment.format === 'mp4' ||
                                attachment.format === 'mov' ||
                                attachment.format === 'flv' ||
                                attachment.format === 'wmv' ||
                                attachment.format === 'avi'
                              "
                              size="60"
                              file-word-outline
                              color="red lighten-1"
                              >mdi-file-video-outline</v-icon
                            >
                            <v-icon
                              v-else-if="attachment.format === 'dwg'"
                              size="60"
                              file-word-outline
                              color="indigo lighten-2"
                              >mdi-file-cad</v-icon
                            >
                            <v-icon
                              v-else-if="
                                attachment.format === 'zip' ||
                                attachment.format === 'rar' ||
                                attachment.format === '7-zip'
                              "
                              size="60"
                              file-word-outline
                              color="lime lighten-1"
                              >mdi-folder-zip-outline</v-icon
                            >
                            <v-icon
                              v-else-if="attachment.format === 'txt'"
                              size="60"
                              file-word-outline
                              color="light-green darken-3"
                              >mdi-script-text-outline</v-icon
                            >
                            <v-icon v-else size="60" file-word-outline color="indigo lighten-1"
                              >mdi-file-question-outline</v-icon
                            >
                          </template>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
                <v-card v-else class="mx-auto" tile>
                  <v-list-item
                    v-for="(attachment, index) in tempAttachmentChanged"
                    :key="`attachment-${index}`"
                    style="border-bottom: 1px solid #e0e0e0"
                  >
                    <v-list-item-content>
                      <v-list-item-title>
                        <v-icon
                          v-if="attachment.format === 'pdf'"
                          size="30"
                          file-word-outline
                          color="red darken-1"
                          >mdi-file-pdf-outline</v-icon
                        >
                        <v-icon
                          v-else-if="
                            attachment.format === 'doc' ||
                            attachment.format === 'docx' ||
                            attachment.format === 'odt'
                          "
                          size="30"
                          file-word-outline
                          color="blue darken-1"
                          >mdi-file-word-outline</v-icon
                        >
                        <v-icon
                          v-else-if="
                            attachment.format === 'jpg' ||
                            attachment.format === 'jpeg' ||
                            attachment.format === 'png' ||
                            attachment.format === 'tif' ||
                            attachment.format === 'bmp'
                          "
                          size="30"
                          file-word-outline
                          color="deep-purple darken-1"
                          >mdi-file-image-outline</v-icon
                        >
                        <v-icon
                          v-else-if="attachment.format === 'xls' || attachment.format === 'xlsx'"
                          size="30"
                          file-word-outline
                          color="teal darken-1"
                          >mdi-file-excel-outline</v-icon
                        >
                        <v-icon
                          v-else-if="
                            attachment.format === 'pptx' ||
                            attachment.format === 'pptm' ||
                            attachment.format === 'ppt'
                          "
                          size="30"
                          file-word-outline
                          color="orange darken-3"
                          >mdi-file-powerpoint-outline</v-icon
                        >
                        <v-icon
                          v-else-if="
                            attachment.format === 'mp4' ||
                            attachment.format === 'mov' ||
                            attachment.format === 'flv' ||
                            attachment.format === 'wmv' ||
                            attachment.format === 'avi'
                          "
                          size="30"
                          file-word-outline
                          color="red lighten-1"
                          >mdi-file-video-outline</v-icon
                        >
                        <v-icon
                          v-else-if="attachment.format === 'dwg'"
                          size="30"
                          file-word-outline
                          color="indigo lighten-2"
                          >mdi-file-cad</v-icon
                        >
                        <v-icon
                          v-else-if="
                            attachment.format === 'zip' ||
                            attachment.format === 'rar' ||
                            attachment.format === '7-zip'
                          "
                          size="30"
                          file-word-outline
                          color="lime lighten-1"
                          >mdi-folder-zip-outline</v-icon
                        >
                        <v-icon
                          v-else-if="attachment.format === 'txt'"
                          size="30"
                          file-word-outline
                          color="light-green darken-3"
                          >mdi-script-text-outline</v-icon
                        >
                        <v-icon v-else size="30" file-word-outline color="indigo lighten-1"
                          >mdi-file-question-outline</v-icon
                        >
                        {{ attachment.name }}.{{ attachment.format }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-card>
              </template>
            </v-card-text>
            <v-card-actions>
              <v-btn
                class="BYekan"
                :disabled="tempAttachment == null || btnLoader"
                :loading="btnLoader"
                :color="btnColor"
                @click="uploadFieldChange"
                >Agregar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
      <!--Insert New Document Dialog End-------------------------------------------------------------------->

      <!-- Empieza Dialogo Manejo de Archivos -->
      <v-dialog v-model="dialogf" max-width="1024px">
        <div id="app"></div>
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container>
              <!-- Pruebas OJO -->
              <!--  <v-row class="mt-5">
                <v-col v-for="(file, i) in files" :key="i" cols="12" md="4" xs="12">
                  <v-img :src="file.fire_url"> </v-img>
                </v-col>
              </v-row> -->
              <!-- INICIA    thumbnail -->
              <v-col cols="12" md="12" xs="12">
                <!-- Insertar Archivos -->
                <template v-if="badgeCounter">
                  <template v-if="files.length > 0">
                    <v-badge
                      bordered
                      :color="files.length === maxFileCount ? 'error' : 'success'"
                      overlap
                      :content="files.length"
                    >
                      <v-btn disabled :color="btnColor" @click="openInputDocumentModal">
                        Agregar Archivo
                      </v-btn>
                    </v-badge>
                  </template>
                  <template v-else>
                    <v-btn disabled :color="btnColor" @click="openInputDocumentModal">
                      Agregar Archivo
                    </v-btn>
                  </template>
                </template>
                <template v-if="!badgeCounter">
                  <v-btn disabled :color="btnColor" @click="openInputDocumentModal">
                    Agregar Archivo
                  </v-btn>
                </template>
                <!-- FIN Insertar Archivos -->
                <!-- imagenes en thumbnail -->
                <v-row class="mt-5">
                  <template v-if="files.length > 0">
                    <v-col v-for="(file, index) in files" :key="index" cols="12" md="4" xs="12">
                      <v-card
                        :shaped="shaped"
                        :outlined="outlined"
                        :raised="raised"
                        :tile="tile"
                        class="mx-auto"
                        max-width="344"
                      >
                        <template
                          v-if="
                            file.fire_nomarchivo.split('.').pop().toLowerCase() === 'jpg' ||
                            file.fire_nomarchivo.split('.').pop().toLowerCase() === 'jpeg' ||
                            file.fire_nomarchivo.split('.').pop().toLowerCase() === 'png' ||
                            file.fire_nomarchivo.split('.').pop().toLowerCase() === 'tif' ||
                            file.fire_nomarchivo.split('.').pop().toLowerCase() === 'bmp'
                          "
                        >
                          <!-- DIBUJA LA IMAGEN -->
                          <v-img :src="file.fire_url" height="200px"></v-img>
                        </template>
                        <template v-else>
                          <v-list-item-avatar
                            style="margin-top: 0"
                            tile
                            width="100%"
                            height="192"
                            color="blue-grey lighten-5"
                          >
                            <template>
                              <a :src="file.fire_url"></a>
                              <v-icon
                                v-if="file.fire_nomarchivo.split('.').pop().toLowerCase() === 'pdf'"
                                size="120"
                                file-word-outline
                                color="red darken-1"
                                >mdi-file-pdf-outline</v-icon
                              >
                              <v-icon
                                v-else-if="
                                  file.fire_nomarchivo.split('.').pop().toLowerCase() === 'doc' ||
                                  file.fire_nomarchivo.split('.').pop().toLowerCase() === 'docx' ||
                                  file.fire_nomarchivo.split('.').pop().toLowerCase() === 'odt'
                                "
                                size="120"
                                file-word-outline
                                color="blue darken-1"
                                >mdi-file-word-outline</v-icon
                              >
                              <v-icon
                                v-else-if="
                                  file.fire_nomarchivo.split('.').pop().toLowerCase() === 'xls' ||
                                  file.fire_nomarchivo.split('.').pop().toLowerCase() === 'xlsx'
                                "
                                size="120"
                                file-word-outline
                                color="teal darken-1"
                                >mdi-file-excel-outline</v-icon
                              >
                              <v-icon
                                v-else-if="
                                  file.fire_nomarchivo.split('.').pop().toLowerCase() === 'pptx' ||
                                  file.fire_nomarchivo.split('.').pop().toLowerCase() === 'pptm' ||
                                  file.fire_nomarchivo.split('.').pop().toLowerCase() === 'ppt'
                                "
                                size="120"
                                file-word-outline
                                color="orange darken-3"
                                >mdi-file-powerpoint-outline</v-icon
                              >
                              <v-icon
                                v-else-if="
                                  file.fire_nomarchivo.split('.').pop().toLowerCase() === 'mp4' ||
                                  file.fire_nomarchivo.split('.').pop().toLowerCase() === 'mov' ||
                                  file.fire_nomarchivo.split('.').pop().toLowerCase() === 'flv' ||
                                  file.fire_nomarchivo.split('.').pop().toLowerCase() === 'wmv' ||
                                  file.fire_nomarchivo.split('.').pop().toLowerCase() === 'avi'
                                "
                                size="120"
                                file-word-outline
                                color="red lighten-1"
                                >mdi-file-video-outline</v-icon
                              >
                              <v-icon
                                v-else-if="
                                  file.fire_nomarchivo.split('.').pop().toLowerCase() === 'dwg'
                                "
                                size="120"
                                file-word-outline
                                color="indigo lighten-2"
                                >mdi-file-cad</v-icon
                              >
                              <v-icon
                                v-else-if="
                                  file.fire_nomarchivo.split('.').pop().toLowerCase() === 'zip' ||
                                  file.fire_nomarchivo.split('.').pop().toLowerCase() === 'rar' ||
                                  file.fire_nomarchivo.split('.').pop().toLowerCase() === '7-zip'
                                "
                                size="120"
                                file-word-outline
                                color="lime lighten-1"
                                >mdi-folder-zip-outline</v-icon
                              >
                              <v-icon
                                v-else-if="
                                  file.fire_nomarchivo.split('.').pop().toLowerCase() === 'txt'
                                "
                                size="120"
                                file-word-outline
                                color="light-green darken-3"
                                >mdi-script-text-outline</v-icon
                              >
                              <v-icon v-else x-large file-word-outline color="indigo lighten-1"
                                >mdi-file-question-outline</v-icon
                              >
                            </template>
                          </v-list-item-avatar>
                        </template>

                        <v-card-subtitle class="one-line">
                          <a target="_blank" :href="file.fire_url">{{ file.fire_nomarchivo }}</a>
                          <!-- {{ file.fire_nomarchivo }} -->
                        </v-card-subtitle>
                        <v-card-subtitle
                          v-if="Number((file.fire_size / 1000).toFixed(1)) < 1024"
                          class="mt2"
                        >
                          <v-chip color="teal lighten-2" label text-color="white">
                            {{ Number((file.fire_size / 1000).toFixed(1)) + '  KB' }}
                            <v-icon right>mdi-harddisk</v-icon>
                          </v-chip>
                        </v-card-subtitle>
                        <v-card-subtitle v-if="Number((file.fire_size / 1000).toFixed(1)) > 1024">
                          <v-chip color="teal lighten-2" label text-color="white">
                            {{ Number((file.fire_size / 1000 / 1024).toFixed(1)) + '  MB' }}
                            <v-icon right>mdi-harddisk</v-icon>
                          </v-chip>
                        </v-card-subtitle>
                        <v-divider class="mx-4"></v-divider>
                        <v-spacer></v-spacer>
                        <!--<v-card-actions>
                <v-btn text @click="openDeleteDialog(index , '')" >{{selectedLang[lang].delete}}</v-btn>
                <v-spacer></v-spacer>

              </v-card-actions>-->
                        <v-card-actions style="padding: 0">
                          <v-tooltip right>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                v-if="deletePermission"
                                text
                                fab
                                disabled
                                v-on="on"
                                @click="openDeleteDialog(index, '')"
                                ><v-icon color="red">mdi-trash-can-outline</v-icon></v-btn
                              >
                            </template>
                            <span class="BYekan">Borrar</span>
                          </v-tooltip>
                          <!--                           <v-tooltip right>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                v-if="editPermission"
                                text
                                fab
                                v-on="on"
                                @click="openEditDocumentDialog(file, index)"
                                ><v-icon color="green">mdi-pencil-outline</v-icon></v-btn
                              >
                            </template>
                            <span class="BYekan">Editar</span>
                          </v-tooltip>
 -->
                          <!-- OJO QUITAR -->
                          <v-spacer></v-spacer>

                          <!-- comento Roger -->
                          <!-- <v-btn
                        v-if="attachment.file.tags.length > 0 || attachment.file.description !== ''"
                        icon
                        @click.prevent="
                          attachment.file.showDetailState = !attachment.file.showDetailState
                        "
                      >
                        <v-icon>{{
                          attachment.file.showDetailState ? 'mdi-chevron-up' : 'mdi-chevron-down'
                        }}</v-icon>
                      </v-btn> -->
                        </v-card-actions>

                        <!--  <v-expand-transition>
                      <template
                        v-if="attachment.file.tags.length > 0 || attachment.file.description !== ''"
                      >
                        <div v-show="attachment.file.showDetailState">
                          <v-divider></v-divider>
                          <v-chip-group
                            v-if="attachment.file.tags.length > 0"
                            multiple
                            active-class="primary--text"
                            style="padding: 8px"
                          >
                            <v-chip
                              v-for="(tag, index) in attachment.file.tags"
                              :key="`attachment-${index}`"
                              style="margin: 5px"
                            >
                              {{ tag }}
                            </v-chip>
                          </v-chip-group>
                          <v-card-text
                            v-if="attachment.file.description != null"
                            style="text-align: justify; height: 200px; overflow-y: auto"
                          >
                            {{ attachment.file.description }}
                          </v-card-text>
                        </div>
                      </template>
                    </v-expand-transition> -->
                      </v-card>
                    </v-col>
                  </template>
                </v-row>
              </v-col>
              <!-- FINALIZA  thumbnail -->

              <!-- handyUploader -->
              <!-- <v-row>
                
                <v-col cols="12">
                  <handy-uploader
                    :files.sync="registryDocFile"
                    :fileUploaderType="'thumbnail'"
                    :maxFileSize="10240"
                    :imageCompressor="true"
                    :imageCompressLevel="0.8"
                    :maxFileCount="10"
                    :badgeCounter="true"
                    :editPermission="false"
                    :changeFileName="false"
                    :addFileDescription="true"
                    :addFileTag="false"
                    :lang="'es'"
                    :tags="['Tag 1', 'Tag 2', 'Tag 3', 'Tag 4']"
                  >
                  </handy-uploader>
                </v-col>
              </v-row> -->
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="checkChanges">Cancelar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Termina Dialogo Manejo de Archivos -->

      <!-- Empieza Dialogo PRINCIPAL-->
      <!-- <v-dialog v-model="dialog" max-width="500px"> -->
      <v-dialog v-model="dialog" max-width="1024px">
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
            <v-img src="@/assets/logo_secogey.jpg" width="20%" height="20%"></v-img>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row v-show="!iscancel">
                <!-- Campo ENTIDAD -->
                <v-col cols="6">
                  <v-select
                    v-model="$v.editedItem.id_entidad.$model"
                    :items="entidades"
                    :menu-props="{ top: true, offsetY: true }"
                    label="Entidades*"
                    item-text="ent_nombre"
                    item-value="id_entidad"
                    persistent-hint
                    disabled
                    dense
                    hint="Seleciona Entidad"
                    return-object
                    :error-messages="id_tipo_retenErrors"
                    @input="changed = true"
                    @blur="$v.editedItem.id_entidad.$touch()"
                  >
                  </v-select>
                </v-col>
                <!-- Campo RETENCION -->
                <v-col cols="3">
                  <v-select
                    v-model="$v.editedItem.id_tipo_reten.$model"
                    :items="retenciones"
                    :menu-props="{ top: true, offsetY: true }"
                    label="Retenciones*"
                    item-text="reten_nombre"
                    item-value="id_tipo_reten"
                    persistent-hint
                    disabled
                    dense
                    hint="Seleciona Retención"
                    return-object
                    :value="$store.myValue"
                    :error-messages="id_tipo_retenErrors"
                    @input="setSelectedCta"
                    @blur="$v.editedItem.id_tipo_reten.$touch()"
                  >
                  </v-select>
                </v-col>
                <!-- Campo cuentas -->
                <v-col cols="3">
                  <v-select
                    v-model="$v.editedItem.id_cta.$model"
                    :items="cuentas"
                    :menu-props="{ top: true, offsetY: true }"
                    label="Cuentas*"
                    item-text="cta_clave"
                    item-value="id_cta"
                    persistent-hint
                    disabled
                    dense
                    hint="Seleciona Cuenta"
                    return-object
                    :error-messages="id_ctaErrors"
                    :value="$store.myValue"
                    @input="setSelectedRet"
                    @blur="$v.editedItem.cta_clave.$touch()"
                  >
                  </v-select>
                </v-col>
                <!-- Campo Year -->
                <v-col cols="2">
                  <v-select
                    v-model="$v.editedItem.year_id.$model"
                    :items="years"
                    :menu-props="{ top: true, offsetY: true }"
                    label="Años*"
                    item-text="year_id"
                    item-value="year_id"
                    persistent-hint
                    disabled
                    dense
                    hint="Seleciona año"
                    return-object
                    :error-messages="year_idErrors"
                    @input="changed = true"
                    @blur="$v.editedItem.year_id.$touch()"
                  >
                  </v-select>
                </v-col>
                <v-col cols="5">
                  <v-text-field
                    v-model="editedItem.rec_concepto"
                    label="Concepto"
                    counter="150"
                    dense
                    disabled
                    @input="$v.editedItem.rec_concepto.$reset(), (changed = true)"
                    @blur="$v.editedItem.rec_concepto.$touch()"
                  ></v-text-field>
                </v-col>
                <v-col cols="5">
                  <v-text-field
                    v-model="editedItem.rec_linea_ref"
                    label="Línea de referencia"
                    counter="150"
                    dense
                    disabled
                    @input="$v.editedItem.rec_linea_ref.$reset(), (changed = true)"
                    @blur="$v.editedItem.rec_linea_ref.$touch()"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="editedItem.rec_programa"
                    label="Programa"
                    counter="150"
                    dense
                    disabled
                    @input="$v.editedItem.rec_programa.$reset(), (changed = true)"
                    @blur="$v.editedItem.rec_programa.$touch()"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="editedItem.rec_obra"
                    label="Obra"
                    counter="150"
                    dense
                    disabled
                    @input="$v.editedItem.rec_obra.$reset(), (changed = true)"
                    @blur="$v.editedItem.rec_obra.$touch()"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="editedItem.rec_contrato"
                    label="Contrato"
                    counter="150"
                    dense
                    disabled
                    @input="$v.editedItem.rec_contrato.$reset(), (changed = true)"
                    @blur="$v.editedItem.rec_contrato.$touch()"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="editedItem.rec_num_fact"
                    label="No. Factura"
                    counter="150"
                    dense
                    disabled
                    @input="$v.editedItem.rec_num_fact.$reset(), (changed = true)"
                    @blur="$v.editedItem.rec_num_fact.$touch()"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="editedItem.rec_estatus"
                    label="Estatus"
                    counter="6"
                    disabled
                    dense
                    @input="$v.editedItem.rec_estatus.$reset(), (changed = true)"
                    @blur="$v.editedItem.rec_estatus.$touch()"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    class="text-xs-right"
                    v-model="editedItem.rec_importe"
                    label="Importe"
                    prefix="$"
                    dense
                    disabled
                    @input="$v.editedItem.rec_importe.$reset(), (changed = true)"
                    @blur="$v.editedItem.rec_importe.$touch()"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" v-show="iscancel">
                  <v-text-field
                    v-model="editedItem.rec_motivo_cancela"
                    label="Motivo de Cancelación"
                    counter="150"
                    dense
                    disabled
                    @input="$v.editedItem.rec_motivo_cancela.$reset(), (changed = true)"
                    @blur="$v.editedItem.rec_motivo_cancela.$touch()"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
            <small>*Campo Obligatorio</small>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-checkbox v-model="checkbox" label="Crear otro" :disabled="isEditing"></v-checkbox>
            <v-btn color="red darken-1" text @click="checkChanges">Cancelar</v-btn>
            <v-btn color="blue darken-1" text @click="finaliza" :disabled="$v.$invalid || isCancelado"
              >Finalizar</v-btn>
                        <v-btn color="blue darken-1" text @click="activa" :disabled="$v.$invalid || ! isCancelado"
              >Activar</v-btn>

            <v-btn color="orange darken-1" text @click="rechaza" :disabled="$v.$invalid || isCancelado"
              >Rechazar</v-btn
            >
            <v-btn color="black darken-1" text @click="imprimir" :disabled="$v.$invalid"
              >Imprimir</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Termina Dialogo -->
      <!-- Aqui va progress linear -->
      <v-divider class="mt-3" />
      <v-data-table
        :headers="headers"
        :items="recaudaciones"
        dense
        :search.sync="search"
        :loading="isLoading"
        loading-text="Cargando... Espere por favor"
      >
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
          <!-- <v-icon small @click="deleteItem(item)">mdi-delete</v-icon> -->
          <v-icon small @click="fileItem(item)">mdi-file-export</v-icon>
        </template>

        <!-- Creo el boton de Activo-->
        <template v-slot:item.cta_activo="{ item }">
          <Status :activostr="item.cta_activo" tipo="String" />
        </template>

        <template v-slot:item.rec_importe="{ item }">
          {{ formatPrice(item.rec_importe) }}
        </template>

        <template v-slot:[`item.concepto`]="{ item }">
          <div class="name-info-title">{{ item.rec_concepto }}</div>
          <div class="mail-info-subtitle">{{ item.rec_linea_ref }}</div>
          <div class="mail-info-subtitle">{{ item.rec_programa }}</div>
        </template>

        <template v-slot:[`item.obra`]="{ item }">
          <div class="name-info-title">{{ item.rec_obra }}</div>
          <div class="mail-info-subtitle">{{ item.rec_contrato }}</div>
        </template>

        <template v-slot:no-data>
          <!-- <v-btn color="primary">Reset</v-btn> -->
          ¡No hay datos para mostrar!
        </template>
      </v-data-table>
      <!-- Termina Tabla de cuentas -->
      <!-- Empieza DataExporter -->
      <!-- <DataExporter :dataArray="cuentas" :dataFields="fields" fileName="cuentas" /> -->
      <!-- Termina DataExporter -->
    </base-material-card>
  </v-container>
</template>

<script>
import ConfirmationDialog from '@/components/general/ConfirmationDialog.vue'
import Status from '@/components/general/StatusInfo.vue'
import { getValidToken } from '@/store/helpers.js'
import { validationMixin } from 'vuelidate'
//import { required, minLength, maxLength } from 'vuelidate/lib/validators'
import { required } from 'vuelidate/lib/validators'
//import DataExporter from '@/components/general/DataExporter.vue'
import jsPDF from 'jspdf'
//import handyUploader from '@/components/handyUploader.vue'

//import lightbox from 'vlightbox'
//import axios from 'axios'
//Vue.use(lightbox)
export default {
  props: {
    deletePermission: {
      type: Boolean,
      default: true,
    },
    editPermission: {
      type: Boolean,
      default: true,
    },
    badgeCounter: {
      type: Boolean,
      default: true,
    },
    fileAccept: String,
    addFileTag: {
      type: Boolean,
      default: false,
    },
    addFileDescription: {
      type: Boolean,
      default: false,
    },
    changeFileName: {
      type: Boolean,
      default: false,
    },
    btnColor: {
      type: String,
      default: 'info',
    },
    maxFileCount: {
      type: Number,
      default: 10,
    },
  },
  components: {
    ConfirmationDialog,
    Status,
    //DataExporter,
    //handyUploader,
  },

  data: () => ({
    //handyUploader
    registryDocFile: [],
    btnLoader: false,
    tempAttachmentChanged: [],
    insertDocumentDialog: false,
    tempAttachment: [],
    shaped: false,
    outlined: false,
    raised: false,
    tile: false,
    fileUploaderSnackBarAlertColor: 'green',
    fileUploaderSnackText: '',
    deleteDocumentDialog: false,
    //
    //logo_yuc: 'https://demos.creative-tim.com/material-dashboard-pro/assets/img/faces/avatar.jpg',
    //logo_yuc: '../assets/logo_secogey.jpg',
    //logo_yuc: require('../assets/logo_secogey.png'),
    //logo_yuc: require('@assets/logo_secogey.png'),
    //logo_yuc: 'http://www.contraloria.yucatan.gob.mx/Template/assets/img/logo.png',
    usuario: JSON.parse(localStorage.getItem('user')),
    search: undefined,
    isLoading: false,
    checkbox: false,
    isEditing: false,
    dialog: false,
    dialogf: false,
    isSure: false,
    overlay: false,
    changed: false,
    iscancel: false,
    isfile: false,
    isCancelado: false,
    isRevision: false,
    headers: [
      { text: 'Id', align: 'start', sortable: false, value: 'rec_id' },
      { text: 'Entidad', value: 'ent_nombre' },
      { text: 'Retención', value: 'reten_nombre' },
      { text: 'Concepto', value: 'concepto', align: 'start' },
      { text: 'Obra', value: 'obra' },
      { text: '$ Importe', value: 'rec_importe' },
      { text: 'Estatus', value: 'rec_estatus' },
      { text: 'Acciones', value: 'actions', sortable: false },
    ],
    //
    value: [],
    entidades: [],
    retenciones: [],
    recaudaciones: [],
    cuentas: [],
    years: [],
    files: [],
    editedIndex: -1,
    editedItem: {
      rec_id: 0,
      id_entidad: 0,
      year_id: 0,
      id_usr: 0,
      id_tipo_reten: 0,
      id_cta: 0,
      rec_concepto: '',
      rec_linea_ref: '',
      rec_programa: '',
      rec_obra: '',
      rec_contrato: '',
      rec_importe: 0.0,
      rec_num_fact: '',
      rec_estatus: '',
      rec_motivo_cancela: '',
    },
    defaultItem: {
      rec_id: 0,
      id_entidad: 0,
      year_id: 0,
      id_usr: 0,
      id_tipo_reten: 0,
      id_cta: 0,
      rec_concepto: '',
      rec_linea_ref: '',
      rec_programa: '',
      rec_obra: '',
      rec_contrato: '',
      rec_importe: 0.0,
      rec_num_fact: '',
      rec_estatus: '',
      rec_motivo_cancela: '',
    },
    //Para Exportar
    fields: {
      Entidad: 'id_cta',
      Tipo: 'cta_clave',
      Nombre: 'ent_nombre',
      Activo: 'cta_activo',
    },
  }),

  mixins: [validationMixin],
  //Validaciones para los campos del formulario
  validations: {
    editedItem: {
      //ent_nombre: { required, minLength: minLength(3), maxLength: maxLength(255) },
      id_cta: { required },
      //id_tipo: { required, minLength: minLength(3), maxLength: maxLength(255) },
      //reten_nombre: { required, minLength: minLength(3), maxLength: maxLength(100) },
      id_tipo_reten: { required },
      id_entidad: { required },
      year_id: { required },
    },
  },

  computed: {
    //Titulo de los formularios
    formTitle() {
      return this.editedIndex === -1
        ? 'Nueva Recaudación'
        : this.iscancel
        ? 'Cancelar Recaudación # ' + this.editedItem.rec_id
        : this.isfile
        ? 'Archivos para la Recaudación # ' + this.editedItem.rec_id
        : 'Editar Recaudación # ' + this.editedItem.rec_id
    },
    id_ctaErrors() {
      const errors = []
      if (!this.$v.editedItem.id_cta.$dirty) return errors
      !this.$v.editedItem.id_cta.required && errors.push('Este campo es requerido')
      return errors
    },
    id_tipo_retenErrors() {
      const errors = []
      if (!this.$v.editedItem.id_tipo_reten.$dirty) return errors
      !this.$v.editedItem.id_tipo_reten.required && errors.push('Este campo es requerido')
      return errors
    },
    id_entidadErrors() {
      const errors = []
      if (!this.$v.editedItem.id_entidad.$dirty) return errors
      !this.$v.editedItem.id_entidad.required && errors.push('Este campo es requerido')
      return errors
    },
    year_idErrors() {
      const errors = []
      if (!this.$v.editedItem.year_id.$dirty) return errors
      !this.$v.editedItem.year_id.required && errors.push('Este campo es requerido')
      return errors
    },
  },

  watch: {
    dialog(val) {
      val || this.close()
    },
    dialogf(val) {
      val || this.close()
    },
    changeFileName: function () {
      this.$emit('update:changeFileName', this.changeFileName)
    },
    tempAttachment: function (newValue) {
      if (this.tempAttachment.length > 0) this.getAttachmentDetails(newValue)
      else this.tempAttachmentChanged = []
    },
    badgeCounter: function () {
      this.$emit('update:badgeCounter', this.badgeCounter)
    },
    cardType: function () {
      this.$emit('update:cardType', this.cardType)
      this.setCardTheme()
    },
  },
  //1ero
  created() {
    this.iniciando()
  },

  methods: {
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(',', '.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    //Refresca Datos para la tabla
    async iniciando() {
      let jwt = await getValidToken(this)
      this.obtenerEntidades(jwt)
      this.obtenerRetenciones(jwt)
      this.obtenerCuentas(jwt)
      this.obtenerRecaudaciones(jwt)
      this.obtenerYears(jwt)
      //this.obtenerFiles(jwt, 1)
    },
    //Obtiene todos los años para el select
    async obtenerYears(jwt) {
      //async obtenerEntidades(jwt) {
      this.isLoading = true
      if (jwt != null) {
        let payload = { jwt: jwt }
        this.$store
          .dispatch('year/fetchYear', payload)
          .then((response) => {
            this.years = response.data
            this.isLoading = false
          })
          .catch((err) => {
            this.isLoading = false
            this.$store.commit('ALERT', {
              color: 'error',
              text: err.response.data.error,
              // Enviar a inicio de sesión
            })
          })
      }
    },
    //Obtiene todos las ENTIDADES para el select
    async obtenerEntidades(jwt) {
      //async obtenerEntidades(jwt) {
      //console.log('obtenerEntidades ' + isAdmin + idEntidad)
      this.isLoading = true
      let params = null
      //let jwt = await getValidToken(this)
      if (jwt != null) {
        let payload = { jwt: jwt, params: params }
        this.$store
          .dispatch('entidad/fetchEntidad', payload)
          .then((response) => {
            this.entidades = response.data
            this.isLoading = false
          })
          .catch((err) => {
            this.isLoading = false
            this.$store.commit('ALERT', {
              color: 'error',
              text: err.response.data.error,
              // Enviar a inicio de sesión
            })
          })
      }
    },
    //Obtiene todos laas Retenciones para el select
    async obtenerRetenciones(jwt) {
      this.isLoading = true
      let params = null
      params = 'filtro?campo1=reten_activo&tipo1=igual&valor1=1'
      if (jwt != null) {
        let payload = { jwt: jwt, params: params }
        this.$store
          .dispatch('retencion/fetchRetencion', payload)
          .then((response) => {
            this.retenciones = response.data
            this.isLoading = false
          })
          .catch((err) => {
            this.isLoading = false
            this.$store.commit('ALERT', {
              color: 'error',
              text: err.response.data.error,
              // Enviar a inicio de sesión
            })
          })
      }
    },
    //Obtiene Todos las Entidades para la tabla
    async obtenerCuentas(jwt) {
      this.isLoading = true
      let params = null
      if (jwt != null) {
        let payload = { jwt: jwt, params: params }
        this.$store
          .dispatch('cuenta/fetchCuenta', payload)
          .then((response) => {
            this.cuentas = response.data
            this.isLoading = false
          })
          .catch((err) => {
            this.isLoading = false
            this.$store.commit('ALERT', {
              color: 'error',
              text: err.response.data.error,
              // Enviar a inicio de sesión
            })
          })
      }
    },
    //Obtiene Todas las recaudaciones
    async obtenerRecaudaciones(jwt) {
      this.isLoading = true
      let params = null
              params =
          'filtro?campo1=rec_estatus&tipo1=igual&valor1=CAN' +
          '&logico2=or&campo2=rec_estatus&tipo2=igual&valor2=REV'

      if (jwt != null) {
        let payload = { jwt: jwt, params: params }
        this.$store
          .dispatch('recaudacion/fetchRecaudacion', payload)
          .then((response) => {
            this.recaudaciones = response.data
            this.isLoading = false
          })
          .catch((err) => {
            this.isLoading = false
            this.$store.commit('ALERT', {
              color: 'error',
              text: err.response.data.error,
              // Enviar a inicio de sesión
            })
          })
      }
    },
    //Obtiene todos laas Retenciones para el select
    async obtenerFiles(jwt, rec_id) {
      this.isLoading = true
      let params = null
      params = 'filtro?campo1=rec_id&tipo1=igual&valor1=' + rec_id
      if (jwt != null) {
        let payload = { jwt: jwt, params: params }
        //
        if (this.files.length > 0) {
          this.files = []
          this.files.length = 0
        }
        this.$store
          .dispatch('recaudacion/fetchRecaudacionFile', payload)
          .then((response) => {
            this.files = response.data

            this.isLoading = false
          })
          .catch((err) => {
            this.isLoading = false
            this.$store.commit('ALERT', {
              color: 'error',
              text: err.response.data.error,
              // Enviar a inicio de sesión
            })
          })
      }
    },
    //Nuevo
    nuevaCaptura() {
      //Se inicializan los valores de la nueva captura
      this.editedItem.id_entidad = this.entidades[0].id_entidad
      this.editedItem.year_id = this.years[0].year_id
      this.editedItem.id_tipo_reten = this.retenciones[0].id_tipo_reten
      let cuenta = this.cuentas.find(
        (elemento) => elemento.id_tipo_reten == this.editedItem.id_tipo_reten
      )
      this.editedItem.id_cta = cuenta.id_cta
      this.editedItem.rec_estatus = 'CAP'
    },
    // Editar Tipo
    editItem(item) {
      this.iscancel = false
      this.isfile = false
      this.isEditing = true
      this.editedIndex = this.recaudaciones.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
      this.isCancelado = false
      if (this.editedItem.rec_estatus == 'CAN') {
        this.isCancelado = true
      }
    },
    async fileItem(item) {
      this.iscancel = false
      this.isEditing = false
      this.isfile = true
      this.editedIndex = this.recaudaciones.indexOf(item)
      this.editedItem = Object.assign({}, item)
      //this.editedItem.rec_estatus = 'CAN'
      this.dialogf = true
      
      //Cargar las imagenes que corresponden a cada recaudacion
      let jwt = await getValidToken(this)
      this.obtenerFiles(jwt, this.editedItem.rec_id)
    },
    // Cancelar Recaudación
    deleteItem(item) {
      //const index = this.cuentas.indexOf(item)
      //confirm('Esta seguro que desea eliminar este registro?') && this.cuentas.splice(index, 1)
      //this.Borrar(item.id_cta)

      this.iscancel = true
      this.isEditing = false
      this.isfile = false
      //this.isEditing = true
      this.editedIndex = this.recaudaciones.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.editedItem.rec_estatus = 'CAN'
      this.dialog = true
    },
    //Borrar en BD es desActivar
    async Borrar(index) {
      this.overlay = true
      this.$v.$touch()

      let body = {
        //_id: this.editedItem.id_tipo,
        id_cta: index,
        //cta_clave: this.editedItem.cta_clave,
        rec_motivo_cancela: this.editedItem.rec_motivo_cancela,
      }
      let jwt = await getValidToken(this)
      let payload = { jwt: jwt, body: body }
      payload.id = index
      this.$store
        .dispatch('entidad/deleteEntidad', payload)
        .then(() => {
          this.$store.commit('ALERT', {
            color: 'success',
            text: 'El registro se eliminó con éxito',
          })
          this.overlay = false
        })
        .catch((err) => {
          this.$store.commit('ALERT', {
            color: 'error',
            text: err.response.data.msg,
            // Enviar a inicio de sesión
          })
          this.overlay = false
        })
      Object.assign(this.cuentas[this.editedIndex], this.editedItem)
    },
    //Borrar Archivo en BD
    async BorrarFile(index, nomArchivo) {
      //console.log(index)
      //console.log(nomArchivo)
      this.overlay = true
      this.$v.$touch()

      let body = {
        fire_nomarchivo_new: nomArchivo,
        fire_id: index,
      }
      let jwt = await getValidToken(this)
      let payload = { jwt: jwt, body: body }
      payload.id = index
      this.$store
        .dispatch('recaudacion/deleteRecaudacionFile', payload)
        .then(() => {
          this.$store.commit('ALERT', {
            color: 'success',
            text: 'El registro se eliminó con éxito',
          })
          this.overlay = false
        })
        .catch((err) => {
          this.$store.commit('ALERT', {
            color: 'error',
            text: err.response.data.msg,
            // Enviar a inicio de sesión
          })
          this.overlay = false
        })
      Object.assign(this.recaudaciones[this.editedIndex], this.editedItem)
    },
    // Revisar los cambios en el formulario
    checkChanges() {
      if (this.changed) {
        this.isSure = true
      } else {
        this.close(false)
        this.changed = false
      }
    },

    cancel(isSure) {
      this.isSure = isSure
      if (this.isSure) {
        this.close(false)
        this.changed = false
      }
    },

    // Cerrar el formulario
    close(checkbox) {
      this.isSure = false
      this.checkbox = checkbox
      if (!this.checkbox) {
        this.dialog = false
        this.dialogf = false
        this.isEditing = false
      }
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
      this.$v.$reset()
    },

    // Guardar el formulario
    async save() {
      this.overlay = true
      this.$v.$touch()
      if (!this.$v.$invalid) {
        let entidad = 0
        if (this.editedItem.id_entidad.id_entidad == null) {
          entidad = this.editedItem.id_entidad
        } else {
          entidad = this.editedItem.id_entidad.id_entidad
        }
        let retencion = 0
        if (this.editedItem.id_tipo_reten.id_tipo_reten == null) {
          retencion = this.editedItem.id_tipo_reten
        } else {
          retencion = this.editedItem.id_tipo_reten.id_tipo_reten
        }
        let cuenta = 0
        if (this.editedItem.id_cta.id_cta == null) {
          cuenta = this.editedItem.id_cta
        } else {
          cuenta = this.editedItem.id_cta.id_cta
        }

        let year = 0
        if (this.editedItem.year_id.year_id == null) {
          year = this.editedItem.year_id
        } else {
          year = this.editedItem.year_id.year_id
        }
        let body = {
          id_entidad: entidad,
          year_id: year,
          id_tipo_reten: retencion,
          id_cta: cuenta,
          rec_concepto: this.editedItem.rec_concepto,
          rec_linea_ref: this.editedItem.rec_linea_ref,
          rec_programa: this.editedItem.rec_programa,
          rec_obra: this.editedItem.rec_obra,
          rec_contrato: this.editedItem.rec_contrato,
          rec_importe: this.editedItem.rec_importe,
          rec_num_fact: this.editedItem.rec_num_fact,
          rec_estatus: this.editedItem.rec_estatus,
          rec_motivo_cancela: this.editedItem.rec_motivo_cancela,
        }
        if (this.iscancel) {
          body = []
          body = {
            rec_motivo_cancela: this.editedItem.rec_motivo_cancela,
          }
        }

        //console.log(this.editedItem.rec_motivo_cancela)
        //console.log(body)
        let jwt = await getValidToken(this)
        let payload = { jwt: jwt, body: body }
        if (this.editedIndex > -1) {
          payload.id = this.editedItem.rec_id
          if (this.iscancel) {
            this.$store
              .dispatch('recaudacion/deleteRecaudacion', payload)
              .then(() => {
                this.$store.commit('ALERT', {
                  color: 'success',
                  text: 'El registro se cancelo con éxito',
                })
                this.overlay = false
              })
              .catch((err) => {
                this.$store.commit('ALERT', {
                  color: 'error',
                  text: err.response.data.msg,
                  // Enviar a inicio de sesión
                })
                this.overlay = false
              })
            Object.assign(this.recaudaciones[this.editedIndex], this.editedItem)
          } else {
            this.$store
              .dispatch('recaudacion/editRecaudacion', payload)
              .then(() => {
                this.$store.commit('ALERT', {
                  color: 'success',
                  text: 'El registro se actualizo con éxito',
                })
                this.overlay = false
              })
              .catch((err) => {
                this.$store.commit('ALERT', {
                  color: 'error',
                  text: err.response.data.msg,
                  // Enviar a inicio de sesión
                })
                this.overlay = false
              })
            Object.assign(this.recaudaciones[this.editedIndex], this.editedItem)
          }
        } else {
          this.$store
            .dispatch('recaudacion/addRecaudacion', payload)
            .then((response) => {
              this.$store.commit('ALERT', {
                color: 'success',
                text: 'El registro se creó con éxito',
              })
              this.cuentas.push(response.data)
              this.overlay = false
            })
            .catch((err) => {
              this.$store.commit('ALERT', {
                color: 'error',
                text: err.response.data.msg,
                // Enviar a inicio de sesión
              })
              this.overlay = false
            })
        }
        this.close(this.checkbox)
        this.changed = false
        this.iscancel = false
        jwt = await getValidToken(this)
        await this.obtenerRecaudaciones(jwt)
      }
    },
    setSelectedCta(value) {
      let cuenta = this.cuentas.find((elemento) => elemento.id_tipo_reten == value.id_tipo_reten)
      this.editedItem.id_cta = cuenta.id_cta
    },
    setSelectedRet(value) {
      let retencion = this.cuentas.find((elemento) => elemento.id_tipo_reten == value.id_tipo_reten)
      this.editedItem.id_tipo_reten = retencion.id_tipo_reten

      //@input="setSelected, (changed = true)"
    },
    // Guardar las imagenes para cada documento
    async saveFiles() {
      this.overlay = true
      this.$v.$touch()
      let id_rec = this.editedItem.rec_id
      //alert(this.registryDocFile.length)
      //console.log(this.registryDocFile.length)
      if (this.registryDocFile.length > 0) {
        for (var i in this.registryDocFile) {
          let fd = new FormData()
          var file = this.dataURLtoFile(
            `data:${this.registryDocFile[i].file.format},${this.registryDocFile[i].file.base64}`,
            this.registryDocFile[i].file.name
          )
          fd.append('imagen', file)

          //Grabar
          let jwt = await getValidToken(this)
          let payload = { jwt: jwt, body: fd }
          //console.log(this.editedItem.rec_id)
          payload.id = id_rec
          this.$store
            .dispatch('recaudacion/addRecaudacionFile', payload)
            .then(() => {
              this.$store.commit('ALERT', {
                color: 'success',
                text: 'archivo(s) guardados con éxito',
              })
              this.overlay = false
            })
            .catch((err) => {
              this.$store.commit('ALERT', {
                color: 'error',
                text: err.response.data.msg,
                // Enviar a inicio de sesión
              })
              this.overlay = false
            })

          //Grabar
        } //fin del for
        /*  Object.assign(this.recaudaciones[this.editedIndex], this.editedItem)
        this.close(this.checkbox)
        this.changed = false
        this.iscancel = false
        this.isfile = false
        this.registryDocFile = []
        let jwt = await getValidToken(this)
        this.obtenerRecaudaciones(jwt, this.usuario.usr_rol, this.usuario.id_entidad) */
      }
      Object.assign(this.recaudaciones[this.editedIndex], this.editedItem)
      this.close(this.checkbox)
      this.changed = false
      this.iscancel = false
      this.isfile = false
      this.registryDocFile = []
      let jwt = await getValidToken(this)
      await this.obtenerRecaudaciones(jwt)
    },
    // COnvertidor de archivos en base64
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n)

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }

      return new File([u8arr], filename, { type: mime })
    },
    async createFile(url) {
      //no
      const options = {
        mode: 'cors',
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
        },
      }
      let response = await fetch(url, options)

      //let response = await fetch('http://127.0.0.1:8080/test.jpg')
      let data = await response.blob()
      let metadata = {
        type: 'image/jpeg',
      }
      let file = new File([data], 'test.jpg', metadata)
      // ... do something with the file or return it
      return file
    },
    /////////////////////////////////////////////////////
    openDeleteDialog(index, deleteId) {
      this.btnLoader = false
      this.selectedIndex = index
      this.selectedId = deleteId
      this.deleteDocumentDialog = true
    },
    deleteDocument() {
      //this.registryDocFile.splice(this.selectedIndex, 1)
      //this.documentAttachment = this.registryDocFile

      //this.documentAttachment = this.registryDocFile

      //Borrar en la api
      //console.log(this.selectedIndex)
      //this.BorrarFile(this.selectedIndex)
      let fire_id = this.files[this.selectedIndex].fire_id
      let fire_nomarchivo_new = this.files[this.selectedIndex].fire_nomarchivo_new
      //console.log(fire_id)
      //console.log(fire_nomarchivo_new)
      this.BorrarFile(fire_id, fire_nomarchivo_new)

      this.files.splice(this.selectedIndex, 1)

      this.deleteDocumentDialog = false
    },

    /*   openEditDocumentDialog(item, index) {
      this.btnLoader = false
      this.attachmentIndex = index
      this.editDocumentDialog = true
      this.tempAttachmentChanged = item
    }, */
    openInputDocumentModal() {
      this.btnLoader = false
      this.tempAttachment = []
      this.insertDocumentDialog = true
    },
    async uploadFieldChange() {
      this.btnLoader = true

      if (this.files.length == undefined) {
        //this.files.length = 0
        this.files = []
      }
      for (let [index, item] of this.tempAttachment.entries()) {
        console.log(item)
        //console.log('this.files.length')
        //console.log(this.files.length)
        //console.log(this.files)
        //console.log(this.tempAttachment)
        //let pba = URL.createObjectURL(item)
        //console.log(pba)
        if (this.files.length < this.maxFileCount) {
          if ((item.size / 1000).toFixed(1) > this.maxFileSize) {
            this.fileUploaderSnackBarAlertColor = 'red'
            this.fileUploaderSnackText = `${'Tamaño maximo de archivo es'} ${Math.round(
              this.maxFileSize / 1024
            )} ${'MB'}`
            this.fileUploaderSnackBarAlert = true
          } else {
            let tempFile = {}
            let file = {}
            try {
              this.readerFile = await this.handleUpload(item)
            } catch (e) {
              console.log(e)
            }
            //console.log('this.readerFile')
            //console.log(this.readerFile)
            let fullFileType = this.readerFile.split(';')
            let fileType = fullFileType[0].split(':')
            let status = false
            let imgFile = ''
            let sizeInKb = 0
            if (this.imageCompressor) {
              if (
                fileType[1] === 'image/png' ||
                fileType[1] === 'image/jpg' ||
                fileType[1] === 'image/jpeg' ||
                fileType[1] === 'application/octet-stream' ||
                fileType[1] === 'image/webp'
              ) {
                status = true
                imgFile = await this.compressImage(this.readerFile, fileType[1])
              }
            }
            //tempFile.subject= this.tempAttachmentChanged[index].name + '.' + this.tempAttachmentChanged[index].format;
            let strTemp = this.readerFile.split(',')
            if (status) {
              let imgTemp = imgFile.split(',')
              tempFile.base64 = imgTemp[1]
              sizeInKb = new Buffer(imgFile, 'base64').length
              tempFile.size = String(sizeInKb)
            } else {
              tempFile.base64 = strTemp[1]
              tempFile.size = String(item.size)
            }
            tempFile.name =
              this.tempAttachmentChanged[index].name +
              '.' +
              this.tempAttachmentChanged[index].format
            if (this.tempAttachmentChanged[index].tags === undefined) tempFile.tags = []
            else tempFile.tags = this.tempAttachmentChanged[index].tags
            if (this.tempAttachmentChanged[index].description === undefined)
              tempFile.description = ''
            else tempFile.description = this.tempAttachmentChanged[index].description
            tempFile.showDetailState = false

            tempFile.format = strTemp[0].replace('data:', '')
            file.file = tempFile
            this.registryDocFile.push(file)
            //this.$emit('update:files', this.registryDocFile)
            //this.$emit('update:files', this.files)
            this.$emit('update:documentAttachment', this.registryDocFile)

            let pba = URL.createObjectURL(item)
            //console.log('pba')
            //console.log(pba)
            let itemFileTemp = {}
            itemFileTemp.fire_id = 0
            itemFileTemp.rec_id = this.editedItem.rec_id
            itemFileTemp.fire_url = pba
            itemFileTemp.fire_nomarchivo = item.name
            this.files.push(itemFileTemp)
            //console.log(JSON.stringify(this.registryDocFile));
          }
        } else {
          this.fileUploaderSnackBarAlertColor = 'red'
          this.fileUploaderSnackText = `${'Número maximo de archivos es'} ${this.maxFileCount}`
          this.fileUploaderSnackBarAlert = true
        }
      }
      /* OJO CHECAR MY BIEN */
      //this.files = []
      this.tempAttachmentChanged = []
      this.insertDocumentDialog = false
    },
    compressImage(base64) {
      //no
      const canvas = document.createElement('canvas')
      const img = document.createElement('img')

      return new Promise((resolve, reject) => {
        let imageCompressLevelTemp = this.imageCompressLevel
        img.onload = function () {
          let width = img.width
          let height = img.height

          canvas.width = width
          canvas.height = height

          const ctx = canvas.getContext('2d')
          ctx.drawImage(img, 0, 0, width, height)

          resolve(canvas.toDataURL('image/jpeg', imageCompressLevelTemp))
        }
        img.onerror = function (err) {
          reject(err)
        }
        img.src = base64
      })
    },
    handleUpload(fileAttachment) {
      let reader = new FileReader()
      return new Promise(function (resolve) {
        reader.onloadend = () => {
          resolve(reader.result)
        }
        reader.readAsDataURL(fileAttachment)
        //console.log(reader)
      })
    },
    async getAttachmentDetails(selectedAttachment) {
      for (let item of selectedAttachment) {
        try {
          this.readerFile = await this.handleUpload(item)
        } catch (e) {
          console.log(e)
        }
        let obj = {}
        let name = ''
        name = item.name.split('.')
        obj.format = item.name.substr(item.name.lastIndexOf('.') + 1)
        obj.name = name[0]
        obj.base64 = this.readerFile
        this.tempAttachmentChanged.push(obj)
        //this.files.push(obj)
        //this.files = this.tempAttachmentChanged
      }
    },
    /////////////////////////////////////////////////////
    async imprimir() {
      //Guardar el recibo si esta en estatus = CAP convertir estatus = IMP si no solo ReImprimir
      this.overlay = true
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.imprimeRecibo(this.editedItem.rec_id, this.editedItem)
          this.close(this.checkbox)
        this.changed = false
        this.iscancel = false
        let jwt = await getValidToken(this)
        jwt = await getValidToken(this)
        await this.obtenerRecaudaciones(jwt)
        /* if (this.editedItem.rec_estatus == 'REV') {
          //grabar
          //imprimir
          this.imprimeRecibo(this.editedItem.rec_id, this.editedItem)
        } else {
          //imprimir
          this.imprimeRecibo(this.editedItem.rec_id, this.editedItem)
        } */
      }

      //console.log('imprimeRecibo')
    },
    async imprimeRecibo(rec_id, editedItem) {
      if (editedItem == null) {
        //consultar el documento
        console.log('consultar el documento')
      } else {
        //imprime
        var doc = new jsPDF('p', 'mm', 'letter')
        var logo = new Image()

        logo.src = require('@/assets/logo_secogey.jpg')
        doc.addImage(logo, 'JPEG', 10, 10, 50, 15  )

        doc.setFontSize(14)
        let valor_y = 25
        let valor_x = 65
        //let valor_x2 = 65

        //doc.text = 'Nombre ejecutora: ' + editedItem.id_entidad
        doc.text(valor_x, valor_y, 'SECRETARIA ANTICORRUPCION Y BUEN GOBIERNO ')
        valor_y += 15
        valor_x = 10
        doc.setFontSize(14)
        doc.text(valor_x, valor_y, 'Nombre Ejecutora: ' + editedItem.ent_nombre)
        let valor_x2 = 150
        valor_y += 15
        doc.text(valor_x2, valor_y, 'Folio Consecutivo SAGBY')
        doc.text(valor_x, valor_y, 'Fecha: ' + editedItem.rec_fecha_created)
        valor_y += 10
        doc.text(
          valor_x2,
          valor_y,
          (editedItem.rec_id < 10 ? '0' + editedItem.rec_id : editedItem.rec_id) +
            ' - ' +
            editedItem.year_id
        )
        valor_x = 10
        valor_y += 15
        doc.text(valor_x, valor_y, 'Numero de Recibo Oficial')
        valor_y += 10
        doc.text(valor_x, valor_y, editedItem.rec_linea_ref)

        doc.save(rec_id + '.pdf')
      }
    },
    getImgFromUrl(logo_url, callback) {
      var img = new Image()
      img.src = logo_url
      img.onload = function () {
        callback(img)
      }
    },
    /////////////////////////////////////////////////////
    async finaliza() {
      //Guardar el recibo si esta en estatus = CAP convertir estatus = IMP si no solo ReImprimir
      this.overlay = true
      this.$v.$touch()
      if (!this.$v.$invalid) {
        if (this.editedItem.rec_estatus == 'REV') {
          //grabar
          let jwt = await getValidToken(this)
          let payload = { jwt: jwt }
          payload.id = this.editedItem.rec_id
          this.$store
            .dispatch('recaudacion/finalizaRecaudacion', payload)
            .then(() => {
              this.$store.commit('ALERT', {
                color: 'success',
                text: 'El registro se Modifico con éxito',
              })
              this.overlay = false
            })
            .catch((err) => {
              this.$store.commit('ALERT', {
                color: 'error',
                text: err.response.data.msg,
                // Enviar a inicio de sesión
              })
              this.overlay = false
            })
          Object.assign(this.recaudaciones[this.editedIndex], this.editedItem)
          this.close(this.checkbox)
        this.changed = false
        this.iscancel = false
        jwt = await getValidToken(this)
        await this.obtenerRecaudaciones(jwt)
        } 
      }

      //console.log('imprimeRecibo')
    },
    async rechaza() {
      //Guardar el recibo si esta en estatus = CAP convertir estatus = IMP si no solo ReImprimir
      this.overlay = true
      this.$v.$touch()
      if (!this.$v.$invalid) {
        if (this.editedItem.rec_estatus == 'REV') {
          //grabar
          let jwt = await getValidToken(this)
          let payload = { jwt: jwt }
          payload.id = this.editedItem.rec_id
          this.$store
            .dispatch('recaudacion/RechazaRecaudacion', payload)
            .then(() => {
              this.$store.commit('ALERT', {
                color: 'success',
                text: 'El registro se Modifico con éxito',
              })
              this.overlay = false
            })
            .catch((err) => {
              this.$store.commit('ALERT', {
                color: 'error',
                text: err.response.data.msg,
                // Enviar a inicio de sesión
              })
              this.overlay = false
            })
          Object.assign(this.recaudaciones[this.editedIndex], this.editedItem)
          this.close(this.checkbox)
        this.changed = false
        this.iscancel = false
        jwt = await getValidToken(this)
        await this.obtenerRecaudaciones(jwt)
        } 
      }

      //console.log('imprimeRecibo')
    },
     async activa() {
      //Guardar el recibo si esta en estatus = CAP convertir estatus = IMP si no solo ReImprimir
      this.overlay = true
      this.$v.$touch()
      if (!this.$v.$invalid) {
        if (this.editedItem.rec_estatus == 'CAN') {
          //grabar
          let jwt = await getValidToken(this)
          let payload = { jwt: jwt }
          payload.id = this.editedItem.rec_id
          this.$store
            .dispatch('recaudacion/activaRecaudacion', payload)
            .then(() => {
              this.$store.commit('ALERT', {
                color: 'success',
                text: 'El registro se Modifico con éxito',
              })
              this.overlay = false
            })
            .catch((err) => {
              this.$store.commit('ALERT', {
                color: 'error',
                text: err.response.data.msg,
                // Enviar a inicio de sesión
              })
              this.overlay = false
            })
          Object.assign(this.recaudaciones[this.editedIndex], this.editedItem)
          this.close(this.checkbox)
        this.changed = false
        this.iscancel = false
        jwt = await getValidToken(this)
        await this.obtenerRecaudaciones(jwt)
        } 
      }

      //console.log('imprimeRecibo')
    },
  },
}
</script>
